import React from 'react';
import {Route, IndexRoute} from 'react-router';
import App from './containers/App/App';
import PostsList from './containers/PostsList/PostsList';
import BugFixes from './containers/BugFixes/BugFixes';
import Navigation from './containers/Navigation/Navigation';
import Post from './containers/Post/Post';
import Subscribe from './containers/Subscribe/Subscribe';

const components = {PostsList, Navigation};
const singleArticleomponents = {Post, Navigation};
const bugFixesComponents = {BugFixes, Navigation};
const subscribeComponents = {PostsList, Navigation, Subscribe};
export default function () {
  return (
    <Route path="/" component={App}>
      <IndexRoute components={components}/>
      <Route path="/subscribe" components={subscribeComponents}/>
      <Route path="/article/:id" components={singleArticleomponents}/>
      <Route path="/bug-fixes(/page/:pageIndex)" components={bugFixesComponents}/>
      <Route path="/page/:pageIndex" components={components}/>
      <Route path="/:label(/page/:pageIndex)" components={components}/>
    </Route>
  );
}



// WEBPACK FOOTER //
// ./routes.js